<template>
<div>
  <div class="box box-primary">
    <div class="box-header with-border"> 
      <h3 class="box-title">Voucher</h3>
      <span class="">
        <router-link to="/paymentvoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Payment</router-link>
        <router-link to="/receiptvoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Receipt</router-link>
        <router-link to="/contravoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Contra</router-link>
      </span>
      <div class="box-tools pull-right">
        <router-link to="/voucher" class="btn btn-xs btn-primary"><i class="fa fa-reply"></i> Back</router-link>
        <button type="button" @click="loadData()" title="Reload Ledgers" class="btn btn-xs btn-default"><i class="fa fa-refresh"></i></button>
        <button type="button" data-widget="" class="btn btn-box-tool"><i class="fa fa-remove"></i></button>
      </div>
    </div>  
        <!----> 
    <section class="content">
      <div class="row">
        <div class="col-md-12 bg-green">
          <span class="pull-left">Accounting Voucher Creation</span> <center><strong>{{ $store.state.settingRecord.companyName }}</strong></center>
        </div>
        <div class="col-md-12" style="background-color: #FFFFD9;">
          <div class="col-md-8">
              <div class="row">
                  <div class="col-sm-3">
                      <label>VoucherType <span class="red">*</span></label>
                  </div>
                  <div class="col-sm-3">
                      <select v-model="form.voucherType" disabled name="voucherType" class="form-control" :class="{'is-invalid': form.errors.has('voucherType')}">
                          <option value="journal">Journal</option>
                      </select>
                      <has-error :form="form" field="voucherType"></has-error>
                  </div>
                  <div class="col-sm-3">
                    <select v-model="form.branch_id" @change="loadBranchData()" name="branch_id" class="form-control" :class="{'is-invalid': form.errors.has('branch_id')}">
                      <option v-for="(branch, index) in branches" :key="index" :value="branch.id">{{branch.name}}</option>
                    </select>
                    <has-error :form="form" field="branch_id"></has-error>
                  </div>
                  <div class="col-sm-3">
                      <strong>No:</strong>{{this.form.voucherNo}}
                      <has-error :form="form" field="voucherNo"></has-error>
                  </div>
              </div>
          </div>
          <div class="col-md-4">
              <div class="pull-right">
                  <div class="col-sm-4">
                      <label>Date <span class="red">*</span></label>
                  </div>
                  <div class="col-sm-8">
                      <input v-model="form.date" type="date" name="date" class="form-control" :class="{ 'is-invalid': form.errors.has('date') }" />
                      <has-error :form="form" field="date"></has-error>
                    </div>
              </div>
          </div>
          
          <div class="row">
              <div class="col-sm-12">
                  <hr>
                  <div class="row">        
                      <form @submit.prevent="holdTempVoucher()">  
                          <div class="col-sm-1">
                              <add-ledger></add-ledger>
                          </div>            
                          <div class="col-sm-1">
                              <label>Account <span class="red">*</span></label>
                          </div>                                    
                          <div class="col-sm-3">
                              <v-select :options="ledgers" label="name" name="cr_ledger" placeholder="Select" v-model="ledger" style="background-color: white;"></v-select>
                              <has-error :form="form" field="cr_ledger"></has-error>
                          </div>                      
                          <div class="col-sm-1">
                              <select v-model="type" name="type" class="form-control">
                                  <option value="dr">Dr</option>
                                  <option value="cr">Cr</option>
                              </select>
                          </div>
                          <div class="col-sm-3">
                              <input v-model="amt" type="number" name="amt" placeholder="Amt" step=".01" class="form-control"  />
                              <has-error :form="form" field="amt"></has-error>                               
                          </div>
                          <div class="col-sm-1">
                              <button type="submit" title="Submit" class="btn btn-sm btn-success"><i class="fa fa-plus"></i></button>
                          </div>
                      </form>
                  </div>                        
                  <hr>
                  <table class="table">
                      <thead>
                          <tr>
                              <th width="10%">Type</th>
                              <th width="65%">Particular</th>
                              <th width="10%">Debit</th>
                              <th width="10%">Credit</th>
                              <th width="5%">Action</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(ledger, index) in form.branchLedgers" :key="index" >
                              <td>{{ (ledger.type === 'dr') ? 'By' : 'To' }}</td>
                              <td>
                                  {{ledger.branchLedger.name}}
                                  <br><i>Cur Bal:<strong>{{ledger.branchLedger.balanceAmt}} {{ (ledger.branchLedger.balanceAmt>=0)?'Dr':'Cr' }}</strong></i>
                              </td>
                              <td><strong>{{ (ledger.type == 'dr')?ledger.amt:'' }}</strong></td>
                              <td><strong>{{ (ledger.type == 'cr')?ledger.amt:'' }}</strong></td>
                              <td> <a class="text-danger" @click="removeHoldVoucher(index)"><i class="fa fa-times"></i></a></td>
                          </tr>
                          <tr>
                              <td></td>
                              <td></td>
                              <td><hr><strong>Total: {{this.drTotal}}</strong><hr><hr></td>
                              <td><hr><strong>Total: {{this.crTotal}}</strong><hr><hr></td>
                              <td></td>
                          </tr>
                      </tbody>
                  </table>
                  <div class="form-group">
                      <label>Narration</label>
                      <textarea v-model="form.narration" class="form-control"></textarea>
                  </div>
                  <button v-if="crTotal == drTotal" class="btn btn-success" @click.once="createVoucher()"><i class="fa fa-save"></i> Save</button>
                  <br>
              </div>
          </div>
        </div>
        <hr>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import AddLedger from './AddLedger.vue'
export default {
  name: 'JournalVoucher',
  components: {
    'add-ledger': AddLedger
  },
  data () {
    return {
      branches: [],
      voucher: {},
      form: new Form({
        branch_id: null,
        id: '',
        voucherNo: null,
        date: '',
        voucherType: 'journal',
        narration: '',
        branchLedgers: [],
        status: ''
      }),
      ledgers: [],
      ledger: {},
      type: null,
      amt: null,
      drTotal: 0,
      crTotal: 0
    }
  },
  methods: {
    holdTempVoucher () {
      // console.log(this.ledger)
      if (jQuery.isEmptyObject(this.ledger)) {
        Toast.fire({ icon: 'error', title: 'Please Select a Ledger Account' })
      } else if (this.type == null) {
        Toast.fire({ icon: 'error', title: 'Please select Cr. Dr type' })
      } else if (this.amt == null || this.amt <= 0) {
        Toast.fire({ icon: 'error', title: 'Please select amt to ledger' })
      } else {
        var data = {'type': this.type, 'branchLedger': this.ledger, 'amt': this.amt}
        this.form.branchLedgers.push(data)
        this.drTotal = _.sumBy(this.form.branchLedgers, function (o) { if (o.type === 'dr') { return parseFloat(o.amt) } })
        this.crTotal = _.sumBy(this.form.branchLedgers, function (o) { if (o.type === 'cr') { return parseFloat(o.amt) } })
        this.ledger = {}
        this.type = null
        this.amt = null
      }
    },
    removeHoldVoucher (index) {
      this.form.branchLedgers.splice(index, 1)
      this.drTotal = _.sumBy(this.form.branchLedgers, function (o) { if (o.type === 'dr') { return parseFloat(o.amt) } })
      this.crTotal = _.sumBy(this.form.branchLedgers, function (o) { if (o.type === 'cr') { return parseFloat(o.amt) } })
    },
    createVoucher () {
      if (this.form.branchLedgers.length < 2) {
        Toast.fire({ icon: 'error', title: 'Please Select minimum two Ledger Account' })
      } else {
        // Add Voucher to Server
        this.$axios
          .post('voucher', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            Toast.fire({icon: 'success', title: 'Voucher Added Successfully'})
            // location.reload()
            this.$router.push({name: 'voucher'})
          })
          .catch(function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this))
      }
    },
    loadBranchData () {
      this.form.branchLedgers = []
      this.drTotal = 0
      this.crTotal = 0
      this.$axios
        .get('branchledger?all=all&status=active&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.ledgers = data.data
          $.each(this.ledgers, function (key, value) {
            this.ledgers[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
      this.$axios
        .get('voucherseries', {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.form.voucherNo = parseInt(data.data.journalSeries) + 1
          if (data.data.journalIncludeYear === 'true') {
            this.form.voucherNo = '' + new Date().getFullYear() + this.form.voucherNo
          }
          if (data.data.journalPrefix !== '') {
            this.form.voucherNo = '' + data.data.journalPrefix + this.form.voucherNo
          }
        }).catch(function (error) { console.log(error) })
    },
    loadData () {
      this.$axios
        .get('branch?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        }).catch(function (error) { console.log(error) })
    }
  },
  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
    // Fire.$emit('AfterCreate')
    var date = new Date()
    var day = date.getDate()
    var month = date.getMonth() + 1
    var year = date.getFullYear()
    if (month < 10) month = '0' + month
    if (day < 10) day = '0' + day
    var today = year + '-' + month + '-' + day
    this.form.date = today
    // document.getElementById('theDate').value = today
  }
}
</script>

<style scoped>
.help-block {
    color:red;
}
</style>



// WEBPACK FOOTER //
// JournalVoucher.vue?688589a3